var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.603,
    height: 135.568,
    viewBox: "0 0 114.603 135.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a0616a;}.b{fill:#e6e6e6;}.c{fill:#fff;}.d{fill:#0f4b73;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.803 -64.89)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M150.466,395.024l-4.413.294.588-46.19,7.04,0Z",
    transform: "translate(-103.084 -197.261)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M570.153,460.226h0a3.431,3.431,0,0,1-3.609-3.047l-.728-6.558,3.893-1.084,3.214,5.543a3.431,3.431,0,0,1-2.77,5.146Z",
    transform: "translate(-507.886 -359.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M512.848,397.458a1.958,1.958,0,0,0-1.736,2.118V530.907a1.958,1.958,0,0,0,1.736,2.118h111.13a1.958,1.958,0,0,0,1.737-2.118V399.576a1.958,1.958,0,0,0-1.736-2.118Z",
    transform: "translate(-474.309 -332.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M522.612,537.759H630.448v-128.8H522.612Z",
    transform: "translate(-482.425 -340.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M545.149,452.083c-.549,0-1,.787-1,1.755s.447,1.755,1,1.755H582.7c.549,0,1-.787,1-1.755s-.447-1.755-1-1.755Z",
    transform: "translate(-497.628 -361.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M544.851,452.083c-.385,0-.7.787-.7,1.755s.314,1.755.7,1.755H571.2c.385,0,.7-.787.7-1.755s-.314-1.755-.7-1.755Z",
    transform: "translate(-449.628 -361.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M545.149,488.794c-.549,0-1,.787-1,1.755s.447,1.755,1,1.755H582.7c.549,0,1-.787,1-1.755s-.447-1.755-1-1.755Z",
    transform: "translate(-497.628 -381.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M544.851,488.794c-.385,0-.7.787-.7,1.755s.314,1.755.7,1.755H571.2c.385,0,.7-.787.7-1.755s-.314-1.755-.7-1.755Z",
    transform: "translate(-449.628 -381.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M545.149,525.083c-.549,0-1,.787-1,1.755s.447,1.755,1,1.755H582.7c.549,0,1-.787,1-1.755s-.447-1.755-1-1.755Z",
    transform: "translate(-497.628 -400.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M544.851,525.083c-.385,0-.7.787-.7,1.755s.314,1.755.7,1.755H571.2c.385,0,.7-.787.7-1.755s-.314-1.755-.7-1.755Z",
    transform: "translate(-449.628 -400.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M545.149,561.794c-.549,0-1,.787-1,1.755s.447,1.755,1,1.755H582.7c.549,0,1-.787,1-1.755s-.447-1.755-1-1.755Z",
    transform: "translate(-497.628 -419.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M544.851,561.794c-.385,0-.7.787-.7,1.755s.314,1.755.7,1.755H571.2c.385,0,.7-.787.7-1.755s-.314-1.755-.7-1.755Z",
    transform: "translate(-449.628 -419.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M735.642,452.476a1.755,1.755,0,0,0,0,3.51h7.02a1.755,1.755,0,1,0,0-3.51Z",
    transform: "translate(-606.045 -361.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M735.642,488.476a1.755,1.755,0,0,0,0,3.51h7.02a1.755,1.755,0,1,0,0-3.51Z",
    transform: "translate(-606.045 -380.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M735.642,524.476a1.755,1.755,0,1,0,0,3.51h7.02a1.755,1.755,0,1,0,0-3.51Z",
    transform: "translate(-606.045 -400.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M735.642,560.476a1.755,1.755,0,1,0,0,3.51h7.02a1.755,1.755,0,1,0,0-3.51Z",
    transform: "translate(-606.045 -419.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M727.215,620.84a2.236,2.236,0,1,0,0,4.473h8.946a2.236,2.236,0,1,0,0-4.473Z",
    transform: "translate(-599.758 -450.797)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 91.693,
    height: 0.588,
    transform: "translate(46.647 158.843)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature2.9cfd699d3e621e13f5c3ec68f5b5e5a8.svg";
export { ForwardRef as ReactComponent };